import config from '../../config/index';
import { socketFactory } from '../socketIO';
import layerManager from '../layer.manager';
import * as layerNames from '../layerName';
import Emitter from 'tiny-emitter';
import { SyncContext } from '../socketIO/sync.context';
import * as EventType from '../eventBusType';
//const url = 'http://local.dealer.m.autohome.com.cn:3000/realtime';
const url = config.dealerWs + '/realtime';

/**
 * 操作同步
 */
export class ActionSync extends Emitter {
  /**
   * 操作同步
   * @param {number} userId 用户id
   * @param {string}  用户类型 user：用户  sales：顾问
   */
  constructor(userId, userType) {
    super();
    this.userType = userType;
    this.userId = userId;
    const syncContext = new SyncContext(userType);
    syncContext.on(EventType.REALTIME_SYNC_LOCKED, function () {
      layerManager.open(layerNames.VR_REALTIME_MASK);
    });
    syncContext.on(EventType.REALTIME_SYNC_UNLOCKED, function () {
      layerManager.close(layerNames.VR_REALTIME_MASK);
    });
    this.socketPromise = this.initSocket();
  }
  joinRoom(roomId) {
    this.socketPromise.then((socketClient) => {
      socketClient.setToUserId(roomId);
      socketClient.on('oppositeLeave', () => {
        layerManager.toast(
          { message: '屏幕连接已断开，请稍后！', hasMask: false },
          10000,
        );
      });
      socketClient.on('oppositeJoin', () => {
        this.emit('connected');
      });
      socketClient.on('timeInconsistency', () => {
        console.error('双方时间不同步');
      });
      socketClient.on('delayExcessive', () => {
        console.error('网络延时较长！');
      });
    });
  }
  /**
   * 开始操作同步
   */
  initSocket() {
    if (this.socketPromise) {
      return this.socketPromise;
    }
    let socketPromise = new Promise((resolve) => {
      let options = this.getUserSocketClientOptions(this.userType);
      socketFactory.createSocketClient(options).then((socketClient) => {
        socketClient.on('error', function () {
          layerManager.toast(
            { propsData: { message: '网络异常，请重试！' } },
            1000,
          );
        });
        return resolve(socketClient);
      });
    });
    this.socketPromise = socketPromise;
    return socketPromise;
  }
  /**
   * 停止操作同步
   */
  stop() {
    console.error('触发客户端关闭事件');
    this.socketPromise.then((socketClient) => {
      socketClient.disconnect();
      layerManager.closeToast();
    });
    this.userType = null;
    this.userId = '';
  }
  /**
   * 创建用户端
   * @returns
   */
  getUserSocketClientOptions(userType) {
    return {
      userType: userType,
      isReceive: true,
      isSend: true,
      url,
      userId: this.userId,
      //path: '/user'
      path: '/vrapi/user',   // todo bai,vr带看相关代码，先忽略
    };
  }
}
